import type { CurrencyCode } from "schemas/project";

import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import { useCurrentWorkspaceContext } from "@v2/contexts/WorkspaceDashboardContext";

const useCurrentAnalyticsCurrencyCode = (): CurrencyCode => {
  const { workspace } = useCurrentWorkspaceContext();
  const { project } = useCurrentProjectContext();

  return project?.currency ?? workspace?.currency ?? "USD";
};

export default useCurrentAnalyticsCurrencyCode;
